export enum FileType {
    OPGXRay = 1,
    BPEGumScores = 2, 
    DentalRecords = 3, 
    SignedForms = 4, 
    VideoSimulation = 5, 
    LabReports = 6,
    EconsultationResults = 7,
    RecordsLegacyUploads = 9
} 